module.exports = __webpack_public_path__ + "media/images/top/icon/pink/ico_incorrect-b41171819f1e5b51e5023e538735ef61.svg";